import {cva} from 'class-variance-authority'

/**
 * FileDropzone box (the dashed "Upload Select" area).
 *
 * Border is always the dashed `divider` per Figma — only the fill and helper
 * color change per state. `default` tints on hover; `active` (drag-over) shows
 * the same `action.focus` tint; `error` shows the error tint.
 */
export const DropzoneVariantsFactory = cva(
  'flex w-full cursor-pointer flex-col items-center gap-2 rounded-2xl border border-dashed border-divider px-4 py-6 text-center transition-colors focus-within:outline-none focus-within:ring-2 focus-within:ring-primary',
  {
    variants: {
      state: {
        default: 'hover:bg-action-focus',
        active: 'bg-action-focus',
        error: 'bg-error-states-hover',
      },
      disabled: {
        true: 'cursor-not-allowed opacity-60 hover:bg-transparent',
        false: '',
      },
    },
    defaultVariants: {state: 'default', disabled: false},
  },
)
